import React, {useEffect, useState} from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import {LinkContainer} from 'react-router-bootstrap'
import NavDropdown from 'react-bootstrap/NavDropdown';
import useSignOut from 'react-auth-kit/hooks/useSignOut';

import {
    MDBIcon
} from "mdb-react-ui-kit";


function TopNavbar(props) {
    const signOut = useSignOut()

    const [financePermission, setFinancePermission] = useState(false);
    const [simplePermission, setSimplePermission] = useState(false);
    const [dropdownActive, setDropdownActive] = useState(false);

    useEffect(() => {
        setSimplePermission(props.readPermissionInitial);
        setFinancePermission(props.writePermissionInitial);
    }, [props]);

    return (
        <Navbar className="navbar" bg="dark">
            <Container>
                <Navbar.Toggle aria-controls="basic-navbar-nav">
                    <MDBIcon icon='bars' fas />
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto" style={{width: '100%'}}>
                        <LinkContainer to="/" hidden={!simplePermission}>
                            <Nav.Link className="first-nav-link" onClick={() => {
                                setDropdownActive(false);
                            }}>Einsätze</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/customers" hidden={!simplePermission}>
                            <Nav.Link onClick={() => {
                                setDropdownActive(false);
                            }}>Kunden</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/employees" hidden={!simplePermission}>
                            <Nav.Link onClick={() => {
                                setDropdownActive(false);
                            }}>Betreuungskräfte</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/office-employees" hidden={!simplePermission}>
                            <Nav.Link onClick={() => {
                                setDropdownActive(false);
                            }}>Mitarbeiter</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/partners" hidden={!simplePermission}>
                            <Nav.Link onClick={() => {
                                setDropdownActive(false);
                            }}>Partner</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/export" hidden={!simplePermission}>
                            <Nav.Link onClick={() => {
                                setDropdownActive(false);
                            }}>Exportieren</Nav.Link>
                        </LinkContainer>
                        <NavDropdown title="Finanzen" id="nav-dropdown" className={dropdownActive ? "white" : ""} hidden={!financePermission}>
                            <LinkContainer to="/invoices">
                                <Nav.Link onClick={() => {
                                    setDropdownActive(true);
                                }}>Rechnungen</Nav.Link>
                            </LinkContainer>
                        </NavDropdown>
                        <LinkContainer to="/users" hidden={!financePermission}>
                            <Nav.Link onClick={() => {
                                setDropdownActive(false);
                            }}>Nutzer</Nav.Link>
                        </LinkContainer>
                    </Nav>

                    <Nav>
                        <LinkContainer to="/login" hidden={simplePermission}>
                            <Nav.Link>Login</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/login" hidden={!simplePermission}>
                            <Nav.Link onClick={() => {
                                signOut();
                                setFinancePermission(false);
                                setSimplePermission(false);
                                setDropdownActive(false);
                            }}>Logout</Nav.Link>
                        </LinkContainer>
                    </Nav>
                </Navbar.Collapse>

            </Container>
        </Navbar>
    );
}

export default TopNavbar;
  